module.exports = __webpack_public_path__ + "media/images/tutorial_body_sp1-04-58b4d3f7f0f1142c2cd1e77804f391c2.png";